/**
 * Return an integer random number between min (included) and max (included)
 */
const randomIntFromInterval = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1) + min);

export default randomIntFromInterval;
